var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticStyle:{"height":"calc(100vh - 90px)","overflow":"hidden"}},[_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('SupportSidebar'),_c('SupportChat'),_c('SupportChatDetails')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }